import React, { useEffect, useState, useRef } from "react"
import axios from "axios"

const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"

export default function WhatsApp() {
  const [status, setStatus]       = useState("carregando")
  const [qrcode, setQrcode]       = useState("")
  const [loading, setLoading]     = useState(false)
  const [testNum, setTestNum]     = useState("")
  const [testResult, setTestResult] = useState<any>(null)
  const intervalRef = useRef<any>(null)

  const verificarStatus = async () => {
    try {
      const r = await axios.get(`${API}/whatsapp/status`)
      setStatus(r.data.status)
      if (r.data.status === "open") {
        setQrcode("")
        clearInterval(intervalRef.current)
      }
    } catch { setStatus("desconectado") }
  }

  const buscarQR = async () => {
    setLoading(true)
    try {
      const r = await axios.get(`${API}/whatsapp/qrcode`)
      setQrcode(r.data.qrcode)
      // Verificar status a cada 3s
      clearInterval(intervalRef.current)
      intervalRef.current = setInterval(verificarStatus, 3000)
    } catch { alert("Erro ao buscar QR Code") }
    finally { setLoading(false) }
  }

  const desconectar = async () => {
    if (!window.confirm("Desconectar WhatsApp?")) return
    try {
      await axios.delete(`${API}/whatsapp/desconectar`)
      setStatus("desconectado")
      setQrcode("")
    } catch {}
  }

  const testarNumero = async () => {
    if (!testNum) return
    setTestResult(null)
    try {
      const r = await axios.get(`${API}/whatsapp/verificar/${testNum.replace(/\D/g,"")}`)
      setTestResult(r.data)
    } catch { setTestResult({existe:false,erro:"Erro ao verificar"}) }
  }

  useEffect(() => {
    verificarStatus()
    return () => clearInterval(intervalRef.current)
  }, [])

  const statusCor = status==="open"?"#22c55e":status==="connecting"?"#f59e0b":"#64748b"
  const statusLabel = status==="open"?"✅ Conectado":status==="connecting"?"⏳ Conectando...":"❌ Desconectado"

  return (
    <div style={{padding:24,height:"100%",overflowY:"auto",maxWidth:600}}>
      <div style={{marginBottom:24}}>
        <h2 style={{fontSize:20,fontWeight:700}}>💬 WhatsApp</h2>
        <p style={{fontSize:13,color:"#64748b"}}>Integração via Evolution API para verificação de números e envio de mensagens</p>
      </div>

      {/* Status */}
      <div className="card" style={{marginBottom:16}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
          <div>
            <div style={{fontSize:13,color:"#64748b",marginBottom:4}}>Status da conexão</div>
            <div style={{fontSize:16,fontWeight:700,color:statusCor}}>{statusLabel}</div>
          </div>
          <div style={{display:"flex",gap:8}}>
            <button className="btn btn-ghost" style={{fontSize:12}} onClick={verificarStatus}>🔄 Atualizar</button>
            {status==="open" && (
              <button className="btn btn-ghost" style={{fontSize:12,color:"#f87171"}} onClick={desconectar}>
                Desconectar
              </button>
            )}
          </div>
        </div>

        {status !== "open" && (
          <>
            <button className="btn btn-primary" onClick={buscarQR} disabled={loading}
              style={{width:"100%",justifyContent:"center",marginBottom:16}}>
              {loading?"⏳ Gerando QR Code...":"📱 Conectar WhatsApp"}
            </button>

            {qrcode && (
              <div style={{textAlign:"center"}}>
                <div style={{fontSize:12,color:"#64748b",marginBottom:12}}>
                  Abra o WhatsApp no celular → Dispositivos conectados → Conectar dispositivo
                </div>
                <div style={{background:"white",padding:16,borderRadius:12,display:"inline-block"}}>
                  <img src={qrcode} alt="QR Code WhatsApp" style={{width:200,height:200}} />
                </div>
                <div style={{fontSize:11,color:"#475569",marginTop:8}}>
                  ⏳ Aguardando leitura... (atualiza automaticamente)
                </div>
              </div>
            )}
          </>
        )}

        {status === "open" && (
          <div style={{background:"#0d2e1a",border:"1px solid #22c55e",borderRadius:8,padding:12,fontSize:12,color:"#4ade80"}}>
            ✅ WhatsApp conectado! A verificação de números está ativa na tela de Motoristas.
          </div>
        )}
      </div>

      {/* Teste de número */}
      {status === "open" && (
        <div className="card">
          <div style={{fontWeight:700,fontSize:14,marginBottom:12}}>🔍 Testar verificação de número</div>
          <div style={{display:"flex",gap:8,marginBottom:12}}>
            <input value={testNum} onChange={e=>setTestNum(e.target.value)}
              placeholder="(94) 99999-9999" style={{flex:1}} />
            <button className="btn btn-primary" onClick={testarNumero}>Verificar</button>
          </div>
          {testResult && (
            <div style={{padding:12,borderRadius:8,
              background:testResult.existe?"#0d2e1a":"#2d1515",
              border:`1px solid ${testResult.existe?"#22c55e":"#dc2626"}`}}>
              <div style={{fontSize:13,fontWeight:600,color:testResult.existe?"#4ade80":"#f87171"}}>
                {testResult.existe?"✅ Número tem WhatsApp":"❌ Número não tem WhatsApp"}
              </div>
              {testResult.numero && <div style={{fontSize:11,color:"#64748b",marginTop:4}}>Número: +{testResult.numero}</div>}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
